
import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  IconButton,
  Tooltip,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  alpha,
} from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import BoltIcon from '@mui/icons-material/Bolt';
import TimelineIcon from '@mui/icons-material/Timeline';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { db } from '../../components/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

// ⬇️ НОВЫЕ карточки
import ForecastCardForecast from './ForecastCardForecast';


import Filters from './Filters';

/* a11y helper */
function a11yProps(index) {
  return {
    id: `taskfeed-tab-${index}`,
    'aria-controls': `taskfeed-tabpanel-${index}`,
  };
}

const TaskFeed = () => {
  const [visibleTasks, setVisibleTasks] = useState(6);

  // filters
  const [predictionTypeFilter, setPredictionTypeFilter] = useState('All');
  const [badgeFilter, setBadgeFilter] = useState('All');
  const [poolRange, setPoolRange] = useState([0, 100000]);
  const [searchQuery, setSearchQuery] = useState('');

  // tabs: 0 - Forecasts, 1 - Live Trade, 2 - Streams
  const [tab, setTab] = useState(0);

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [howOpen, setHowOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const q = query(collection(db, 'promos'), where('status', '==', 'approved'));
        const querySnapshot = await getDocs(q);
        const fetchedTasks = querySnapshot.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            ...data,
            applications: data.applications || 0,
            progressStatus: data.progressStatus || 'NEW',
            token: data.token || 'prUSD',
            creatorType: data.creatorType || (data.isForecast ? 'user' : 'company'),
            boostStatus: data.boostStatus || { active: false },
            avatar: data.avatar || 'https://placehold.co/60x60',
            creator: data.creator || data.company || 'Unknown',
            companyName: data.companyName || data.company || 'Unknown',
            assets: data.assets || [],
            images: data.images || [],
            pool: Number(data.pool) || 0,
            category: data.category || 'N/A',
            likes: data.likes || 0,
            views: data.views || 0,
            creatorLevel: data.creatorLevel || 'Beginner',
            aiSuggested: data.aiSuggested || false,
            top: data.top || false,
            tipsEnabled: data.tipsEnabled || false,
            predictionType: data.predictionType || null,
            due: data.due || 'N/A',
            verified: data.verified || false,
            successfulAnalyses: data.successfulAnalyses || 0,
            marketStatus: data.marketStatus || 'open',
            creatorBet: data.creatorBet || null,
            outcome: data.outcome || null,
            positionStatus: data.positionStatus || null,     // для LIVE
            positionSnapshot: data.positionSnapshot || null, // запасной признак
            isForecast: data.isForecast === true,            // строго булево
          };
        });
        setTasks(fetchedTasks);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching promos:', err);
        setLoading(false);
      }
    };
    fetchTasks();
  }, []);

useEffect(() => {
  // Вспомогательные переменные (локально в useEffect)
  let timer = null;
  let running = false;
  let lastOk = 0;

  // Функция visible
  function visible() {
    return typeof document !== 'undefined' ? document.visibilityState === 'visible' : true;
  }

  // Функция tickOnce
  async function tickOnce(signal) {
    if (!CF_URL) {
      if (!running || !timer) console.warn('[tickPump] CF_URL не задан — пропускаю вызовы');
      return;
    }
    const res = await fetch(`${CF_URL}?_=${Date.now()}`, {
      mode: 'cors',
      credentials: 'omit',
      signal
    });
    if (!res.ok) throw new Error(`CF ${res.status}`);
    await res.json().catch(() => ({}));
    lastOk = Date.now();
  }

  // Функция startTickPump
  function startTickPump(opts = {}) {
    if (running) return () => {};
    running = true;

    if (opts.url) CF_URL = opts.url;
    const OK = Number.isFinite(+opts.okInterval) ? +opts.okInterval : 2500;
    const ERR = Number.isFinite(+opts.errInterval) ? +opts.errInterval : 7000;

    const controller = new AbortController();

    const loop = async () => {
      if (!running) return;
      try {
        if (visible()) {
          await tickOnce(controller.signal);
        }
        const dt = Date.now() - lastOk;
        const delay = dt < 20000 ? OK : ERR;
        timer = setTimeout(loop, delay);
      } catch (e) {
        timer = setTimeout(loop, ERR);
      }
    };

    const onVis = () => {
      if (!running) return;
      clearTimeout(timer);
      timer = setTimeout(loop, 200);
    };

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', onVis);
    }

    loop();

    return () => {
      running = false;
      try { controller.abort(); } catch {}
      try {
        if (typeof document !== 'undefined') {
          document.removeEventListener('visibilitychange', onVis);
        }
      } catch {}
      clearTimeout(timer);
    };
  }

  // URL CF (твой)
  let CF_URL = 'https://europe-west3-starwa-94ac5.cloudfunctions.net/refreshTicksFromSelected';

  // Запуск
  const stopPump = startTickPump({
    url: CF_URL,
    okInterval: 2500,  // 2.5s
    errInterval: 7000, // 7s на ошибку
  });

  return () => stopPump(); // Cleanup
}, []); 


  // признаки для вкладок
  const isLiveOpen = (t) => {
    const st = (t?.positionStatus?.state || '').toLowerCase();
    return st === 'open';
  };
  const hasAnyPosition = (t) => {
    return Boolean(t?.positionSnapshot && (t.positionSnapshot.symbol || t.positionSnapshot.entry));
  };

  // общая фильтрация
  const baseFiltered = useMemo(() => {
    return tasks
      .filter((task) =>
        searchQuery
          ? (task.title || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (task.company || task.creator || '').toLowerCase().includes(searchQuery.toLowerCase())
          : true
      )
      .filter((task) =>
        predictionTypeFilter === 'All' ||
        task.predictionType?.toUpperCase() === predictionTypeFilter
      )
      .filter((task) =>
        badgeFilter === 'All' ||
        (badgeFilter === 'Expert Analyst' && (task.successfulAnalyses || 0) >= 10)
      )
      .filter((task) => task.pool >= poolRange[0] && task.pool <= poolRange[1]);
  }, [tasks, searchQuery, predictionTypeFilter, badgeFilter, poolRange]);

  // фильтрация по вкладке
  const tabFiltered = useMemo(() => {
     if (tab === 0) {

   // Forecasts: по kind, с бэкапом на старые записи
   return baseFiltered.filter((t) =>
     t.kind === 'forecast' || (!t.kind && t.isForecast === true && !hasAnyPosition(t))
   );
  }
  if (tab === 1) {

   // Live Trade: по kind, с бэкапом на старые записи
   return baseFiltered.filter((t) =>
     t.kind === 'live' || (!t.kind && (isLiveOpen(t) || hasAnyPosition(t)))
   );
  }
  return [];
}, [baseFiltered, tab]);

  // пагинация
  const paged = useMemo(() => tabFiltered.slice(0, visibleTasks), [tabFiltered, visibleTasks]);

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
    setVisibleTasks(6); // сброс пагинации при смене вкладки
  };

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <Container
      maxWidth="xl"
      disableGutters={isMobile}
      sx={{ py: 4, px: { xs: 0, sm: 3, md: 4 } }}
    >
      {/* Headline + How It Works */}
      <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1, px: { xs: 1.25, sm: 0 } }}>
        <Typography
          variant="h5"
          sx={{ fontFamily: "'Bruno Ace SC', sans-serif", color: '#0f172a', lineHeight: 1 }}
        >
          {tab === 0 ? 'Forecasts' : tab === 1 ? 'Live Trade' : 'Streams'}
        </Typography>

        <Tooltip title="How it works" arrow>
          <IconButton
            onClick={() => setHowOpen(true)}
            size="small"
            sx={{ border: '1px solid #e5e7eb', borderRadius: 2, p: 0.5, '&:hover': { backgroundColor: '#f8fafc' } }}
          >
            <InfoOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Tabs */}
      <Box sx={{ px: { xs: 1.25, sm: 0 }, mb: 1 }}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          aria-label="Forecasts / Live / Streams"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 40,
            '& .MuiTab-root': {
              minHeight: 40,
              textTransform: 'none',
              fontWeight: 800,
              color: '#334155',
            },
            '& .Mui-selected': { color: '#111827' },
            '& .MuiTabs-indicator': { height: 3, backgroundColor: '#111827' },
          }}
        >
          <Tab icon={<TimelineIcon sx={{ fontSize: 18, mr: .75 }} />} iconPosition="start" label="Forecasts" {...a11yProps(0)} />
          <Tab icon={<BoltIcon sx={{ fontSize: 18, mr: .75 }} />} iconPosition="start" label="Live Trade" {...a11yProps(1)} />
          <Tab icon={<PlayCircleOutlineIcon sx={{ fontSize: 18, mr: .75 }} />} iconPosition="start" label="Streams" {...a11yProps(2)} />
        </Tabs>
      </Box>

      {/* Filters */}
      {(tab === 0 || tab === 1) && (
        <Box sx={{ px: { xs: 1.25, sm: 0 } }}>
          <Filters
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            predictionTypeFilter={predictionTypeFilter}
            setPredictionTypeFilter={setPredictionTypeFilter}
            badgeFilter={badgeFilter}
            setBadgeFilter={setBadgeFilter}
            poolRange={poolRange}
            setPoolRange={setPoolRange}
          />
        </Box>
      )}

      {/* Content */}
      {tab !== 2 ? (
        <>
          <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ mt: 1, mx: { xs: 0, sm: 0 } }}>
           {paged.map((task, idx) => (
  <Grid item key={task.id || idx} xs={6} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        minWidth: 0,
        '& > *': { flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 },
        px: { xs: 0.5, sm: 0 },
      }}
    >
      {tab === 0 && <ForecastCardForecast task={task} compact={isMobile} />}
      
      {tab === 2 && null /* стримы позже */ }
    </Box>
  </Grid>
))}
          </Grid>

          {paged.length === 0 && (
            <Box sx={{ textAlign: 'center', color: alpha('#0f172a', 0.6), py: 6 }}>
              <Typography sx={{ fontWeight: 800, mb: .75 }}>
                {tab === 1 ? 'No active Live positions' : 'Nothing found'}
              </Typography>
              <Typography variant="body2">Try changing filters or switching tabs.</Typography>
            </Box>
          )}

          {visibleTasks < tabFiltered.length && (
            <Box sx={{ mt: 3, px: { xs: 1.25, sm: 0 } }}>
              <Button
                variant="outlined"
                onClick={() => setVisibleTasks((prev) => prev + 6)}
                sx={{ borderRadius: '8px', px: 4, py: 1.25, fontWeight: 600 }}
              >
                Show More
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Box sx={{ textAlign: 'center', color: alpha('#0f172a', 0.7), py: 8 }}>
          <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>Streams (soon)</Typography>
          <Typography variant="body2">Live broadcasts with positions and commentary will appear here.</Typography>
        </Box>
      )}

      {/* How it works snackbar */}
      <Snackbar
        open={howOpen}
        onClose={() => setHowOpen(false)}
        autoHideDuration={9000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setHowOpen(false)} severity="info" sx={{ width: '100%', alignItems: 'flex-start' }}>
          <Typography sx={{ fontWeight: 800, mb: .5 }}>How It Works</Typography>
          <Typography variant="body2">1. Create your Profile — fill in the details and connect the crypto wallet</Typography>
          <Typography variant="body2">2. Create and Participate — create analytical forecasts or find what you like and take part in the promotion</Typography>
          <Typography variant="body2">3. Get Tokens for Your Actions — each participant can find their own monetization option</Typography>
          <Typography variant="body2">4. Swap, Buy/Sell, Withdraw — enjoy your earnings</Typography>
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default TaskFeed;
